<template>
  <div>
    <div class="award">
      <el-dialog
        class="awardDialog"
        :visible.sync="dialogAward"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <img
          style="width: 32vw"
          src="https://img.51xinlong.com/xladmin/static/ecology/awardBox1.png"
        />
        <div class="btnArea">
          <div class="wrap">
            <img
              @click="dialogAward = false"
              src="https://img.51xinlong.com/xladmin/static/ecology/awardBtn1.png"
            />
            <img
              @click="showQues"
              src="https://img.51xinlong.com/xladmin/static/ecology/awardBtn2.png"
            />
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 问卷调查 -->
    <div class="ques">
      <el-dialog
        class="awardDialog"
        :visible.sync="quesDialog"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div class="quesWrap">
          <div class="quesOutLine">
            <i
              class="el-icon-close"
              @click="quesDialog = false"
              style="
                cursor: pointer;
                position: absolute;
                right: 2vw;
                top: 4vh;
                font-size: 24px;
              "
            ></i>
            <label
              style="
                font-size: 3.462vh;
                font-weight: normal;
                color: #272727;
                margin-bottom: 2vh;
              "
            >
              灵活用工生态产品调查问卷
            </label>
            <div
              style="
                width: 57px;
                height: 3px;
                background-color: #006afe;
                margin-bottom: 10vh;
              "
            ></div>
            <div
              class="item"
              :key="index"
              v-for="(item, index) in questionList"
            >
              <label v-html="item.label" class="label"></label>
              <div class="ansBox">
                <div
                  @click="tapCell(item2, index2, item, index)"
                  class="ansBoxCell"
                  v-for="(item2, index2) in item.answer"
                  :key="index2"
                >
                  <div
                    style="margin-right: 10px"
                    v-show="item2.select == false"
                  >
                    <img
                      style="width: 2.092vh; height: 2.092vh; display: flex"
                      src="https://img.51xinlong.com/xladmin/static/ecology/unselect.png"
                    />
                  </div>
                  <div
                    v-show="item2.select == true"
                    style="
                      margin-right: 10px;
                      width: 2.092vh;
                      height: 2.092vh;
                      background-color: #006afe;
                      border-radius: 4px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <img
                      style="width: 1.2vh"
                      src="https://img.51xinlong.com/xladmin/static/ecology/icon-yes.png"
                    />
                  </div>
                  <div
                    v-show="item2.select == 'error'"
                    style="
                      margin-right: 10px;
                      width: 2.092vh;
                      height: 2.092vh;
                      background-color: #ff2c29;
                      border-radius: 4px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <img
                      style="width: 1.2vh"
                      src="https://img.51xinlong.com/xladmin/static/ecology/icon-no.png"
                    />
                  </div>
                  <span>{{ item2.name }}</span>
                </div>
              </div>
            </div>
            <div
              style="
                height: 41.018vh;
                width: 49.302vw;
                background-color: #f3f5f7;
                padding: 0px 66px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
              "
            >
              <label
                style="
                  font-size: 32px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #272727;
                  width: 100%;
                  text-align: center;
                  margin-bottom: 2.395vh;
                "
              >
                填写收件地址
              </label>
              <div class="inputWrap">
                <div class="inputCell">
                  <span class="label">收货人</span>
                  <input v-model="form.receiver" />
                </div>
                <div class="inputCell">
                  <span class="label">手机号码</span>
                  <input v-model="form.phone" />
                </div>
                <div class="inputCell">
                  <span class="label">收获地址</span>
                  <!-- <input /> -->
                  <el-form style="width: 100%">
                    <el-form-item>
                      <el-cascader
                        clearable
                        placeholder="请选择省市区"
                        :props="props"
                        v-model="form.province"
                        :options="json.data"
                        @change="handleChangeSSQ"
                      ></el-cascader>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="inputCell">
                  <span class="label">详细地址</span>
                  <input v-model="form.addressDetail" />
                </div>
              </div>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 2.083vh;
                margin-bottom: 3.333vh;
              "
              @click="submiltData"
            >
              <div class="submilt">提&nbsp;&nbsp;交</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import json from "../../../../public/citys.json";

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      json,
      form:{
        province:[]
      },
      props: {
        value: "label",
      },
      answer: {
        answer1: [],
        answer2: [],
        answer3: [],
        answer4: [],
        answer5: [],
      },
      questionList: [
        {
          label:
            '01<span style="color:#FF2C29">·灵活用工生态产品</span>包含哪些产品？（多选）',
          answer: [
            { name: "灵活用工结算系统", select: false },
            { name: "灵工贷产品", select: false },
            { name: "灵活用工园区资源", select: false },
            { name: "灵活用工保险", select: false },
          ],
          true: [1, 2, 3, 4],
        },
        {
          label:
            '02<span style="color:#FF2C29">·灵工贷产品提供银行</span>是哪个银行？（单选）',
          answer: [
            { name: "招商银行", select: false },
            { name: "平安银行", select: false },
            { name: "网商银行", select: false },
            { name: "中国银行", select: false },
          ],
          true: [3],
        },
        {
          label:
            '03<span style="color:#FF2C29">.灵活用工园区资源</span>包含以下哪些？（多选）',
          answer: [
            { name: "普通灵工（6%专票）", select: false },
            { name: "差额灵工", select: false },
            { name: "大额灵工（不注册）", select: false },
            { name: "自然人代开", select: false },
            { name: "集群注册(个体户）", select: false },
          ],
          true: [1, 2, 3, 4, 5],
        },
        {
          label:
            '04<span style="color:#FF2C29">·灵活用工保险方案</span>产品名称是什么？（多选）',
          answer: [
            { name: "灵工保险", select: false },
            { name: "龙保宝", select: false },
            { name: "雇主责任险", select: false },
            { name: "意外险", select: false },
          ],
          true: [2],
        },
        {
          label:
            '<p>05<span style="color:#FF2C29">·生态系列产品</span>哪个您最感兴趣？（多选）</p>',
          answer: [
            { name: "灵活用工结算系统", select: false },
            { name: "灵工贷产品", select: false },
            { name: "灵活用工园区资源", select: false },
            { name: "灵活用工保险", select: false },
          ],
          true: [1, 2, 3, 4, 5],
        },
      ],
      quesDialog: false,
      dialogAward: false,
    };
  },
  watch: {
  },
  methods: {
    openDialog(){
      console.log(11111)
      this.dialogAward = true;
    },
    // 提交问卷
    async subPaper() {
      let obj = {
        answer: this.form.answer,
        address: this.form.address + this.form.addressDetail,
        phone: this.form.phone,
        receiver: this.form.receiver,
      };
      let res = await this.$api.getQues(obj);
      if (res) {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.quesDialog = false;
      }
    },
    submiltData() {
      this.form.address = this.form.province.join().replace(/,/g, "");
      this.form.answer = JSON.stringify(this.answer);
      if (
        this.form.answer &&
        this.form.address &&
        this.form.phone &&
        this.form.receiver &&
        this.form.addressDetail
      ) {
        this.subPaper();
      } else {
        this.$message.error("请填写完毕后提交");
      }
    },
    handleChangeSSQ(e) {
      console.log(e);
    },
    tapCell(item, index, res, indexMain) {
      let flag = indexMain + 1;
      let ansIndex = `answer${flag}`;
      if (indexMain == 1) {
        if (this.answer[ansIndex].length == 1) {
          return false;
        }
      }
      if (res.true.indexOf(index + 1) == -1) {
        item.select = "error";
      } else {
        item.select = true;
      }

      if (!this.answer[ansIndex].includes(index)) {
        this.answer[ansIndex].push(index);
      }
    },
    showQues() {
      this.dialogAward = false;
      this.quesDialog = true;
    },
  },
};
</script>
<style lang="stylus" scoped>
.submilt
	margin-top 1.851vh
	margin-right 3.851vh
	width 6.197vw
	background-color #0080FF
	border-radius 80px
	height 2.962vh
	justify-content center
	align-items center
	display flex
	color #fff
	cursor pointer
.inputWrap
	width calc(100% - 40px)
	display flex
	justify-content center
	align-items center
	flex-direction column
.inputWrap/deep/.el-form
	margin-top 20px
.inputWrap/deep/.el-input
	width 280px
	outline none
.inputWrap/deep/.el-cascader
	border 1px #292929 dashed
	outline none
.inputCell
	width 100%
	height 6.481vh
	box-sizing border-box
	border-bottom 2px solid #f4f4f4
	display flex
	align-items center
	justify-content flex-start
.inputCell .label
	font-size 1.504vh
	font-weight bold
	color #000000
	width 8.11vw
.inputCell input
	height calc(100% - 20px)
	padding-left 2.962vw
	box-sizing border-box
	outline none
	border 0px
	font-size 1.504vh
	font-weight 400
	color #000000
	background-color #fff
	width 100%
	border 1px dashed #292929
.quesWrap
	width 56.25vw
	height auto
	padding 20px
	box-sizing border-box
.quesOutLine
	width 100%
	background-color #fdfdfd
	padding 8.05vh 4.185vw 2.777vh 4.185vw
	display flex
	justify-content flex-start
	align-items center
	flex-direction column
	box-sizing border-box
	position relative
.quesOutLine label.label
	font-size 1.404vh
	font-weight bold
	color #525252
	height 4.656vh
	background-color #f3f5f7
	display flex
	align-items center
	padding-left 2vw
.quesOutLine .item
	width 100%
	display flex
	justify-content flex-start
	flex-direction column
.quesOutLine .ansBoxCell
	display flex
	flex-direction row
	align-items center
	cursor pointer
.quesOutLine .ansBox
	display flex
	justify-content space-between
	align-items center
	flex-direction row
	height 3.335vh
	padding 0px 2.777vw
	box-sizing border-box
	margin-top 1.851vh
	margin-bottom 8.055vh
.award>>>.el-dialog, .ques>>>.el-dialog
	background-color transparent
	-webkit-box-shadow 0px 0px 0px
	box-shadow 0px 0px 0px
	display flex
	justify-content center
.awardDialog .btnArea
	position absolute
	bottom 3.5vh
	left 0px
	display flex
	width 100%
	justify-content center
	height 10vh
.awardDialog .btnArea .wrap
	width 23vw
	display flex
	justify-content space-between
	align-items center
	padding 0px 0.9vw
	box-sizing border-box
	margin-left 1vw
.awardDialog .btnArea img
	width 10vw
	cursor pointer
.btnArea img
	width 10vw
</style>
